<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title" id="tp">In the Balance</h1>
<p class="right">Winston S. Churchill</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795329326_epub_tp_r1.vue?e90c7082